import { combineReducers } from 'redux'

import account, { AccountState }             from './account.duck'
import auth, { AuthState }                   from './authentication.duck'
import communication, { CommunicationState } from './communication.duck'
import companies, { CompaniesState }         from './companies.duck'
import processes, { ProcessState }           from './processes.duck'
import programs, { ProgramState }            from './programs.duck'
import resources, { ResourcesState }         from './resources.duck'
import sessions, { SessionsState }           from './sessions.duck'
import settings, { SettingsState }           from './settings.duck'
import toast, { ToastState }                 from './toast.duck'
import tripartita, { TripartitaState }       from './tripartita.duck'
import users, { PeopleState }                from './users.duck'

export * from './account.duck'
export * from './authentication.duck'
export * from './communication.duck'
export * from './companies.duck'
export * from './resources.duck'
export * from './sessions.duck'
export * from './settings.duck'
export * from './processes.duck'
export * from './programs.duck'
export * from './toast.duck'
export * from './tripartita.duck'
export * from './users.duck'

export interface ApplicationState {
  account: AccountState
  auth: AuthState
  communication: CommunicationState
  companies: CompaniesState
  resources: ResourcesState
  programs: ProgramState
  processes: ProcessState
  sessions: SessionsState
  settings: SettingsState
  toast: ToastState
  tripartita: TripartitaState
  users: PeopleState
}

export default combineReducers({
  account,
  auth,
  communication,
  companies,
  resources,
  programs,
  processes,
  sessions,
  settings,
  toast,
  tripartita,
  users,
})



// WEBPACK FOOTER //
// ./src/redux/ducks/index.ts